import Vue from 'vue';
import App from './App';
import Vuex from 'vuex'
// eslint-disable-next-line no-unused-vars
import {cloneDeep, isEqual} from 'lodash';
import axios from 'axios'
import VueAxios from 'vue-axios'
import routes from './routes'

import createPersistedState from 'vuex-persistedstate'
//import VuexUndoRedo from 'vuex-undo-redo';


Vue.use(Vuex);
Vue.use(VueAxios, axios)
//Vue.use(VuexUndoRedo);


/* Vuex store */
const store = new Vuex.Store(
    {
        state: {
            topics: []
        },
        getters: {
            getAlertsCount(state) {
                let count = 0;
                state.topics.forEach(item => {
                    count = count + item.alerts.length;
                });

                return count;
            },

            getTopic: (state) => (id) => {
                if (id < 0 || id > state.topics.length) {
                    return null
                }
                return state.topics[id];
            },

            getAlerts(state) {
                let buffer = [];
                state.topics.forEach((topic, index) => {

                    topic.alerts.forEach(item => {
                        buffer.push({
                            'title': topic.title,
                            'topicId': index,
                            'text': item.text,
                            'date': item.date
                        })
                    });
                })
                return buffer;
            }

        },

        plugins: [
            createPersistedState(
                //funziona solo su oggetti non nested
                {paths: []}
            )
        ],


        mutations: {

            initialiseStore(state) {
                //TODO get data from DATABASE
                state.topics = [
                    {

                        'title': 'Wind turbine',
                        'created': '10/2/2022',
                        'last_update': '20/2/2022',
                        'data_source': [
                            {'name': 'patents', 'query': 'wind 2d turbine'},
                            {'name': 'web', 'query': 'wind turbine'},
                            {'name': 'scopus', 'query': 'wind AND turbine'},
                            {'name': 'u-projects', 'query': 'wind AND turbine'},

                        ],
                        'alerts': [
                            {'date': '10/10/2020', 'text': 'Patents | Legal status changed'},
                            {'date': '10/10/2019', 'text': 'Patents | Legal status changed'},
                            {'date': '10/10/2019', 'text': 'Web | New press review found'},

                        ],
                        'history': [
                            {'date': '10/10/2021', 'text': 'Legal status changed to GRANTED'},
                            {'date': '10/10/2020', 'text': 'Legal status changed to PENDING'},
                            {'date': '10/10/2019', 'text': 'Legal status changed to APPLICATION'},
                            {'date': '10/10/2019', 'text': 'Web | New press review found'},
                        ]
                    },

                    {

                        'title': 'Covid 19',
                        'created': '10/2/2022',
                        'last_update': '20/2/2022',
                        'data_source': [

                            {'name': 'web', 'query': 'covid OR coronavirus OR sars19'},


                        ],
                        'alerts': [


                        ],
                        'history': [
                            {'date': '10/10/2021', 'text': 'Found new press review'},
                            {'date': '10/10/2020', 'text': 'Found new blog post'},
                            {'date': '10/10/2019', 'text': 'New website launched'}
                        ]
                    },

                    {

                        'title': 'Brembo Freni',
                        'created': '10/2/2022',
                        'last_update': '20/2/2022',
                        'data_source': [
                            {'name': 'patents', 'query': 'brake 2d pad'},
                            {'name': 'web', 'query': 'brake pad'},
                            {'name': 'scopus', 'query': 'brake AND pad'},
                            {'name': 'u-projects', 'query': 'brake AND pad'},

                        ],
                        'alerts': [
                            {'date': '10/10/2020', 'text': 'Patents | Found new material'},


                        ],
                        'history': [
                            {'date': '10/10/2021', 'text': 'Legal status changed to GRANTED'},
                            {'date': '10/10/2020', 'text': 'Legal status changed to PENDING'},
                            {'date': '10/10/2019', 'text': 'Legal status changed to APPLICATION'},
                            {'date': '10/10/2019', 'text': 'Web | New press review found'},
                        ]
                    },

                 

                ]

            },

            // eslint-disable-next-line no-unused-vars
            setCurrentSheet(state, currentSheet) {


            },


        },

        //Actions can be asynchronous, while Mutations not! That's the big difference
        actions: {
            // eslint-disable-next-line no-unused-vars
            setVariable(context, shape, key, val) {

            },


        }
    })

//Needed to make the store available to js file without vue components
export {store}

window.csrfmiddlewaretoken = document.getElementsByName('csrf-token')[0].getAttribute('content')


/* eslint-disable no-new */
new Vue({
    router: routes,
    el: '#app',
    components: {App},
    store: store,

    beforeCreate() {
        this.$store.commit('initialiseStore');
    },
    template: '<App/>',

});


